<script setup lang="ts">
import HeartIcon from '@/components/icons/heartIcon.vue'
import HomeIcon from '@/components/icons/homeIcon.vue'
import ScanIcon from '@/components/icons/scanIcon.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const winesActiveNames = new Set(['wines', 'wine-info', 'wine-review'])
const isWinesActive = computed(() => winesActiveNames.has(String(route.name || '')))
</script>

<template>
    <footer class="footer">
        <nav class="navigation">
            <RouterLink to="/" class="navigation__link">
                <div class="navigation__link-icon">
                    <HomeIcon :is-active="route.name === 'home'" />
                </div>
                <div class="navigation__link-text">Главная</div>
            </RouterLink>
            <RouterLink to="/scan" class="navigation__link">
                <div class="navigation__link-icon">
                    <ScanIcon :is-active="route.name === 'scan'" />
                </div>
                <div class="navigation__link-text">Сканировать</div>
            </RouterLink>
            <RouterLink
                to="/wines"
                class="navigation__link"
                :class="{ 'router-link-active': isWinesActive }"
            >
                <div class="navigation__link-icon">
                    <HeartIcon :is-active="isWinesActive" />
                </div>
                <div class="navigation__link-text">Мои вина</div>
            </RouterLink>
        </nav>
    </footer>
</template>

<style scoped lang="stylus">
.navigation
    padding 8px 36px 28px
    display flex
    align-items center
    justify-content space-between
    &__link
        display flex
        flex-direction column
        align-items center
        text-decoration none
        width 80px
        &-text
            font-size 12px
            line-height 16px
            color var(--app-text-grey-color)
            .router-link-active &
                color var(--app-text-color)
        &-icon
            width 32px
            height 32px
            margin-bottom 5px

.footer
    position fixed
    bottom 0
    left 0
    right 0
    z-index 100
    background-color var(--app-bg-color)
    border-top 1px solid var(--app-border-color)
</style>
